// Configuring a mallis needs dimensions from LFC and pricing from Scensum; lacking either it stays in the configuration but cannot be edited
export const hasCompleteMallisData = (
  { contextId, erpItemNumber }: { contextId?: string | null; erpItemNumber?: string | null },
  lfcItems: Array<{ configuratorContextId?: string }>,
  erpItems: Array<{ Sku: string | null; PricingInfo?: any }>
): boolean =>
  Boolean(contextId) &&
  lfcItems.some((lfcItem) => lfcItem.configuratorContextId === contextId) &&
  erpItems.some((erpItem) => erpItem.Sku === erpItemNumber && Boolean(erpItem.PricingInfo))
